import React from "react";

import SelectSearch, { fuzzySearch } from 'react-select-search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown, faTimesCircle } from '@fortawesome/pro-light-svg-icons';

import mixtureComponents from '../../data/mixture-components.json'

export default function ComponentFieldGroup({ index, removeGasComponent, validateField }) {

    const options = mixtureComponents.map((item) => {
        return {
            name: `${item.name} - ${item.chemicalFormular} - ${item.CAS}`,
            value: `${item.chemicalFormular}-${item.CAS}`
        }
    });  

    return (
        <div className="component-group-outer mb-4">
            <div className={`component-group component-group-${index} md:flex mb-1`}>
                <SelectSearch
                    className="select-search mb-4 md:mb-0 md:mr-4"
                    filterOptions={(options) => {
                        const filter = fuzzySearch(options);
                        return (q) => filter(q).slice(0, 4);
                    }}
                    name={`component-${index}`}
                    options={options}
                    placeholder="Select component"
                    required
                    search
                />

                <div className="custom-select w-28 inline-block mr-4">
                    <select name={`unit-${index}`} className="w-full" required onChange={validateField}>
                        <option value="">Unit</option>
                        <option value="ppm">ppm</option>
                        <option value="%">%</option>
                    </select>
                    <span className="custom-select-toggle text-secondary text-2xl">
                        <FontAwesomeIcon icon={faChevronCircleDown} />
                    </span>
                </div>

                <input
                    type="text"
                    name={`target-${index}`}
                    className="inline-block w-24 mb-4 md:mb-0 md:ml-auto"
                    placeholder="Target"
                    pattern="^([0-9,\.]+)" required onChange={validateField} />
                
                <button type="button" aria-label="Remove component" className="ml-2 text-primary hover:text-secondary" onClick={(e)=>removeGasComponent(e, index)}><FontAwesomeIcon icon={faTimesCircle} /></button>
            </div>
            <span className="error error-unit" aria-hidden="true"></span>
            <span className="error error-target" aria-hidden="true"></span>
            <span className="error error-component" aria-hidden="true"></span>
        </div>
    )
}